module.exports = __webpack_public_path__ + "static/media/Eject_Tip.1c749805.svg";